import styles from './ProductPageTopBar.module.scss'
import { Responsive } from '../../../core/Responsive'
import Container from '../../../layout/Container'
import ProductBreadcrumbs from '../../../navigation/ProductBreadcrumbs'
import { GroupedProduct, Product } from '../GetProduct.query'

export interface Props {
    product?: Product | GroupedProduct
    /**
     * @deprecated Is no longer used
     */
    close?(): void
}

const ProductPageTopBar = ({ product }: Props) => {
    if (!product) {
        return null
    }

    return (
        <div className={styles.default}>
            <Container className={styles.wrapper}>
                <Responsive md up>
                    <ProductBreadcrumbs product={product} />
                </Responsive>
            </Container>
        </div>
    )
}

export default ProductPageTopBar
